import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { CtaButton } from "./CtaButton";

/** Barra de compra en celular: aparece después de la primera pantalla y se oculta en la oferta. */
export function StickyBar() {
  const [pastHero, setPastHero] = useState(false);
  const [offerVisible, setOfferVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setPastHero(window.scrollY > window.innerHeight * 0.9);
    onScroll();
    window.addEventListener("scroll", onScroll, {
      passive: true
    });
    const offer = document.getElementById("offer-details");
    const observer = offer ? new IntersectionObserver(([entry]) => setOfferVisible(entry.isIntersecting), {
      threshold: 0.1
    }) : null;
    if (offer && observer) observer.observe(offer);
    return () => {
      window.removeEventListener("scroll", onScroll);
      observer?.disconnect();
    };
  }, []);
  const visible = pastHero && !offerVisible;
  return <AnimatePresence data-id="element-292" data-mp="3ieh5juosfcon">
      {visible && <motion.div initial={{
      y: "100%"
    }} animate={{
      y: 0
    }} exit={{
      y: "100%"
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-20 flex items-center justify-between gap-3 border-t border-gold/30 bg-night/95 px-4 pb-[max(12px,env(safe-area-inset-bottom))] pt-3 text-white backdrop-blur-md md:hidden" data-id="element-293" data-mp="3idfjkv68h5s5">
          <div className="min-w-0" data-id="element-294" data-mp="5270wln9bmui">
            <strong className="block truncate text-sm" data-id="element-295" data-mp="9yxcows13wa4">Tu iPhone, Tu Estudio</strong>
            <small className="block text-xs text-haze" data-id="element-296" data-mp="3rfop16mna8yo">
              <span className="font-bold text-gold" data-id="element-297" data-mp="3rf5j6oa9rb10">27 USD</span> · Libro + 5 bonos
            </small>
          </div>
          <div className="shrink-0" data-id="element-298" data-mp="7aw0kwx94zz">
            <CtaButton href="#offer-details" size="md" data-id="element-299" data-mp="nz84c215xewc">
              Ver oferta
            </CtaButton>
          </div>
        </motion.div>}
    </AnimatePresence>;
}